import { render, staticRenderFns } from "./SitGlobalAnswerStep.vue?vue&type=template&id=3fc5a722&"
import script from "./SitGlobalAnswerStep.vue?vue&type=script&lang=js&"
export * from "./SitGlobalAnswerStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports